// extracted by mini-css-extract-plugin
export default {"flex-center":"cause-carousel_flex-center__KBrm7","flex-vertical-center":"cause-carousel_flex-vertical-center__IrHZ2","carousel":"cause-carousel_carousel__8SVF4"};